export default {
      id: "gangtan-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.271d836e.svg#gangtan",
      toString: function () {
        return this.url;
      }
    }